import React from 'react';
import { color as palette } from "@/constants/palette";

function ChevronRight() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='7'
      height='12'
      viewBox='0 0 7 12'
      fill='none'
    >
      <path
        d='M4.62422 5.99999L0.724219 2.09999C0.540885 1.91665 0.449219 1.68332 0.449219 1.39999C0.449219 1.11665 0.540885 0.883321 0.724219 0.699988C0.907552 0.516654 1.14089 0.424988 1.42422 0.424988C1.70755 0.424988 1.94089 0.516654 2.12422 0.699988L6.72422 5.29999C6.82422 5.39999 6.89505 5.50832 6.93672 5.62499C6.97839 5.74165 6.99922 5.86665 6.99922 5.99999C6.99922 6.13332 6.97839 6.25832 6.93672 6.37499C6.89505 6.49165 6.82422 6.59999 6.72422 6.69999L2.12422 11.3C1.94089 11.4833 1.70755 11.575 1.42422 11.575C1.14089 11.575 0.907552 11.4833 0.724219 11.3C0.540885 11.1167 0.449219 10.8833 0.449219 10.6C0.449219 10.3167 0.540885 10.0833 0.724219 9.89999L4.62422 5.99999Z'
        fill={palette.disabled}
      />
    </svg>
  );
}

export default ChevronRight;
